import {ViewPopup} from './ViewPopup'
import {logError} from '../ui_utils/Utils'
import {TranslationObject} from '@colonist/i18n'
import {ViewPopupOptions} from './ViewPopupOptions'

export class UIPopupController {
    private static popup: ViewPopup

    static createSimplePopup(title: TranslationObject, body: TranslationObject): ViewPopup | undefined {
        return this.create(title, body, () => undefined, () => undefined, true, {
            showXButton: false,
        })
    }

    static createForceRefreshPopup(title: TranslationObject, body: TranslationObject): ViewPopup | undefined {
        return this.create(title, body, () => window.location.reload(), () => undefined, true, {
            showXButton: false,
        })
    }

    static createLargePopup(title: TranslationObject, body: TranslationObject) {
        this.create(title, body, () => undefined, () => undefined, true, {
            showXButton: false,
        })
        this.popup.makeLarge()
    }

    static create(title: TranslationObject, body: TranslationObject, checkAction: () => void, xAction: () => void, canCancel: boolean = true, options?: ViewPopupOptions): ViewPopup | undefined {
        if(!this.canShowNewPopup()) return
        this.popup = new ViewPopup(title, body, checkAction, xAction, canCancel, options)
        this.popup.show()

        return this.popup
    }

    private static canShowNewPopup(): boolean {
        if(this.popup == undefined) return true
        if(this.popup.isRemoved()) return true
        logError('canShowNewPopup', ['Tried to show another popup but failed'])
        return false
    }
}
